const getConditionName = (conditionType) => {
  switch (conditionType) {
    case 'join_program':
      return 'Join referral program'
    case 'invite_referrals':
      return 'Invite referrals'
    case 'referral_bet_sum':
      return 'Referral must place a bet of'
    case 'affiliate_bet_sum':
      return 'Affiliate must place a bet of'
    default:
      return ''
  }
}

export { getConditionName }
